<template>
  <div v-show="opened" :class="[width, {'modal--front': front}]" class="modal">
    <div class="modal-content overflow-hidden" :class="{'p-0': noPad}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalGestor",
    props: ['opened', 'width', 'noPad', 'front'],

    created() {
      this.$parent.$on('openModal', (dados) => {
        this.$emit('loadDadosModal', dados)
      });
    }
  }
</script>

<style scoped>
  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 9990; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

  .modal.modal--front {
    z-index: 10000;
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 30px auto 15px;
    padding: 16px 10px;
    border-radius: 9px;
    max-width: 450px;
    position: relative;
  }

  .modal.full > .modal-content {
    max-width: none;
    width: calc(100% - 32px);
    margin: 16px auto;
    height: calc(100% - 32px);
    position: relative;
    padding: 0;
  }

  .modal.tiny > .modal-content {
    background-color: #fefefe;
    margin: 35px auto 0;
    padding: 20px 10px;
    border-radius: 4px;
    max-width: 325px;
    height: auto;
  }

  .modal.medium > .modal-content {
    max-width: 550px;
    height: auto;
  }

  @media (max-width: 767px) {
    .modal-content {
      margin: 10px auto;
      width: 95%;
      max-width: none;
    }
  }
</style>
